import { render, staticRenderFns } from "./TheBlockHeader.vue?vue&type=template&id=152adfa8&scoped=true&"
import script from "./TheBlockHeader.vue?vue&type=script&lang=js&"
export * from "./TheBlockHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheBlockHeader.vue?vue&type=style&index=0&id=152adfa8&scoped=true&lang=scss&"
import style1 from "./TheBlockHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152adfa8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default,ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default})
